'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _tokenHandler = require('./tokenHandler');

var _tokenHandler2 = _interopRequireDefault(_tokenHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _tokenHandler2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/tokenHandler/index.js
// module id = 722
// module chunks = 11